<template>
  <div :class="[landscape ? 'navbar' : 'navbar-portrait']">
    <img class="logo" src="../assets/logo.png" @click="routeTo('Dashboard')" alt="">
    <div class="btn-lang" @click="routeTo('Contact')">
      <img class="arrow" src="../assets/icon_contact_us.png" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
      }
    },
    props: ['landscape'],
    methods: {
      routeTo: function (name) {
        this.$router.push({name: name})
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../Global.scss';
.navbar {
  width: 100%;
  height: 1rem;
  position: relative;
  @include flexBox(row, nowrap, center, center);
  .logo {
    width: 1.53rem;
    height: .48rem;
    position: absolute;
    left: 1rem;
    cursor: pointer;
  }
  .btn-lang {
    width: .32rem;
    height: .3rem;
    position: absolute;
    right: 1rem;
    cursor: pointer;
    @include flexBox(row, nowrap, center, center);
    img {
      width: 100%;
      height: 100%;
      margin-right: .1rem;
    }
  }
}
.navbar-portrait {
  @extend .navbar;
  .logo {
    left: .3rem;
  }
  .btn-lang {
    right: .3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue